import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-3 md:py-4">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-950 font-bold text-lg md:text-xl whitespace-nowrap"
          aria-label="黑料在线首页"
        >
          <span
            className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg ${
              scrolled || !isHome
                ? "bg-primary-500 text-background-50"
                : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-fire-fill text-sm md:text-base" />
          </span>
          <span className="font-heading">黑料在线</span>
        </Link>

        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          <Link
            to="/"
            className={`text-sm font-medium whitespace-nowrap transition-colors ${
              location.pathname === "/"
                ? "text-primary-500"
                : "text-foreground-700 hover:text-foreground-950"
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === `/category/${cat.slug}`
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium whitespace-nowrap transition-colors ${
              location.pathname === "/about"
                ? "text-primary-500"
                : "text-foreground-700 hover:text-foreground-950"
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <button
            className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100/80 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-sm" />
          </button>
          <button
            className="md:hidden w-8 h-8 flex items-center justify-center rounded-full bg-background-100/80 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${menuOpen ? "close" : "menu"}-line text-sm`} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70 px-4 py-4 space-y-3">
          <Link
            to="/"
            className="block text-sm font-medium text-foreground-700 py-2"
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="block text-sm font-medium text-foreground-700 py-2"
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="block text-sm font-medium text-foreground-700 py-2"
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}